if (!customElements.get('facet-drawer')) {
  customElements.define('facet-drawer', class FacetDrawer extends MainDrawer {
    constructor() {
      super();                  
      
      this.setFocus = debounce((event) => {
        trapFocus(document.querySelector('.drawer--active'), document.querySelector('.drawer--active'))              
      }, 300);

      this.querySelectorAll('.drawer-close').forEach(el => el.addEventListener('click', () => this.closeDrawer()));    
      this.closest('.facet-container').querySelector('.facet__trigger').addEventListener('click', (e) => {        
        e.preventDefault()
        loadScript('facets')
        loadCss('facets')    
        this.openDrawer()      
        this.setFocus()
      });      
    }        
  });
}

// get the sticky element
const stickyElm = document.querySelector('.toolbar--sticky')

const stickyElementObserver = new IntersectionObserver( 
  ([e]) => {      
    if(e.intersectionRatio < 1){        
      e.target.classList.add('isSticky')        
    } else {        
      e.target.classList.remove('isSticky')
    }      
  },
  {threshold: [1]}
);

stickyElementObserver.observe(stickyElm)